import React from "react";
import Information24 from "@carbon/icons-react/lib/information/24";
import PlayOutline24 from "@carbon/icons-react/lib/play--outline/24";
import ReportData24 from "@carbon/icons-react/lib/report--data/24";
import CheckmarkOutline24 from "@carbon/icons-react/lib/checkmark--outline/24";
import Home24 from "@carbon/icons-react/lib/home/24";
import { CommonRoutes, createRoute } from "./common-routes";
import AppSections from "./app-sections";

export const baseURL = "/event/:eventId";

const GameRoutes = {
	...CommonRoutes,
	HOME: createRoute({
		id: "home",
		url: "/",
		isNavItem: true,
		name: "Home",
		icon: <Home24 />,
		appSection: AppSections.GameInfo
	}),
	EVENT_INFORMATION: createRoute({
		id: "event",
		url: `${baseURL}/info`,
		isNavItem: true,
		name: "Info",
		icon: <Information24 />,
		appSection: AppSections.GameInfo
	}),
	TEAM_INFORMATION: createRoute({
		id: "team",
		url: `${baseURL}/team/:teamSide`,
		isNavItem: false
		// appSection: AppSections.TeamInfo
	}),
	TEAM_INFORMATION_VISITOR: createRoute({
		id: "awayTeam",
		url: `${baseURL}/team/away`,
		isNavItem: true,
		appSection: AppSections.TeamInfo,
		name: "Visitor Team"
	}),
	TEAM_INFORMATION_HOME: createRoute({
		id: "homeTeam",
		url: `${baseURL}/team/home`,
		isNavItem: true,
		appSection: AppSections.TeamInfo,
		name: "Home Team"
	}),
	TEAM_IMPORT: createRoute({
		id: "teamImport",
		url: `${baseURL}/team/:teamSide/import`,
		appSection: AppSections.TeamImport
	}),
	TEAM_IMPORT_VISITOR: createRoute({
		id: "awayTeamImport",
		url: `${baseURL}/team/away/import`,
		appSection: AppSections.TeamImport,
		name: "Visitor Team Import"
	}),
	TEAM_IMPORT_HOME: createRoute({
		id: "homeTeamImport",
		url: `${baseURL}/team/home/import`,
		appSection: AppSections.TeamImport,
		name: "Home Team Import"
	}),
	GAME_MODE: createRoute({
		id: "game",
		url: `${baseURL}/game`,
		appSection: AppSections.Game,
		isNavItem: true,
		name: "Game",
		icon: <PlayOutline24 />
	}),
	FINALIZE: createRoute({
		id: "finalize",
		url: `${baseURL}/game/finalize`,
		appSection: AppSections.GameFinalize,
		isNavItem: true,
		name: "Finalize",
		icon: <CheckmarkOutline24 />
	}),
	GAME_CONFIG: createRoute({
		id: "config",
		url: `${baseURL}/game/config`,
		appSection: AppSections.GameConfig,
		name: "Game Config"
	}),
	STATS: createRoute({
		id: "stats",
		url: `${baseURL}/stats`,
		appSection: AppSections.GameStats,
		isNavItem: true,
		name: "Stats",
		icon: <ReportData24 />
	}),
	STREAM: createRoute({
		id: "stream",
		url: `${baseURL}/stream`,
		appSection: AppSections.Stream,
		name: "Stream",
		showMenu: false
	})
};

export { GameRoutes };
